import type { LoginAdminResult } from "@/types/generated/UsedGeneratedTypes";

/**
 * Pure helper : vrai si l'utilisateur a déjà signé la charte d'une
 * application . Vérifie la PRÉSENCE de la clé ( id ou nom ) dans le
 * record {@code chartes} , sans comparaison temporelle .
 *
 * <p><b>Pourquoi présence + pas {@code now > timestamp}</b> ( bug
 * audit ) : l'ancien check {@code new Date().getTime() > timestamp}
 * retournait {@code false} juste après une signature fraîche quand
 * le timestamp serveur était légèrement en avance sur l'horloge
 * client ( skew réseau / clock drift ) , forçant l'utilisateur à
 * recliquer pour signer une 2e fois . Cela générait aussi un
 * doublon en base ( clé {@code name} ET {@code id} ) quand
 * l'identifiant d'application oscillait pendant la phase
 * d'hydratation . Aligné sur le check de présence déjà utilisé par
 * {@code mustSignCharte()} dans GenericLocalApplicationResult.ts .
 */
export function isCharteSigned(
  storedUser: LoginAdminResult | null | undefined,
  applicationId: string | null | undefined,
  applicationName?: string | null,
): boolean {
  const chartes = storedUser?.chartes;
  if (!chartes || typeof chartes !== "object") return false;
  const keys = Object.keys(chartes);
  if (applicationId && keys.includes(applicationId)) return true;
  if (applicationName && keys.includes(applicationName)) return true;
  return false;
}
